var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row vx-marketing-add-to-cart"},[_c('vx-spinner',{ref:"spinner",attrs:{"image":_vm.globals.assetsPath+'images/spinner.gif',"full-screen":""}}),_vm._v(" "),_c('button',{staticClass:"col-xs-12 btn btn-primary add-to-cart-btn",on:{"click":function($event){return _vm.addToCart($event)}}},[_vm._v(_vm._s(_vm.buttontext))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e85ad12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-marketing-add-to-cart/vx-marketing-add-to-cart.html
// module id = null
// module chunks = 